<script setup>
import { ref, onMounted, nextTick } from "vue";
import {
  CalendarDaysIcon,
  ChartBarIcon,
  CheckCircleIcon,
  CursorArrowRippleIcon,
  ExclamationCircleIcon,
  HandThumbDownIcon,
  HandThumbUpIcon,
  InformationCircleIcon,
  LinkIcon,
  PlusCircleIcon,
  ShareIcon,
  Square3Stack3DIcon,
  UserGroupIcon,
  XCircleIcon,
} from "@heroicons/vue/24/solid";
import { useRoute } from "vue-router";
import { getUser, getInfoDashboard } from "@/services/auth";
import { getReportsbyChannels } from "@/services/reports";
import { getProjects } from "@/services/projects";
import { getClients } from "@/services/clients";
import { getChannels } from "@/services/channels";
import { getRules } from "@/services/rules";

console.log("RUTA Home");
const route = useRoute();

/* const currentDate = new Date().toLocaleDateString(); */

const arrayReport1 = ref([]);
const isDropdownOpen = ref(false);
/* const selectedKey = ref(null); */
const user = ref(null);
const dashboardData = ref(null);
const projects = ref([]);
const channels = ref([]);
const projectsComplete = ref([]);
const projectsWithPriorities = ref(0);
const uniqueClientsCount = ref(0);
const uniqueProjectsCount = ref(0);
const uniqueRulesProjectsCount = ref(0);
const activeRulesCount = ref(0);
const expiredRulesCount = ref(0);

/* const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
}; */
/* Click fuera del dropdown */
onMounted(() => {
  document.addEventListener("click", (event) => {
    if (!event.target.closest(".dropdown")) {
      isDropdownOpen.value = false;
    }
  });
});
/* function selectKey(key) {
  selectedKey.value = key;
} */
const selectedTab = ref("proyectos");

function selectTab(tab) {
  selectedTab.value = tab;
}

const numeroContenedor1 = ref(null);
const numero1 = ref(null);
const numeroContenedor2 = ref(null);
const numero2 = ref(null);
const numeroContenedor3 = ref(null);
const numero3 = ref(null);
const numeroContenedor4 = ref(null);
const numero4 = ref(null);

function animateCount(element, finalValue) {
  /*let count = 0;
  const interval = setInterval(() => {
    count += 2000;
    element.textContent = count.toLocaleString();
    if (count >= finalValue) {
      clearInterval(interval);
      element.textContent = finalValue.toLocaleString();
    }
  }, 6);*/
}

//Traer datos del usuario
async function fetchData() {
  const authToken = localStorage.getItem("authToken");
  const clientId = localStorage.getItem("cx");
  try {
    // Obtener datos de usuario y dashboard
    user.value = await getUser(authToken);
    const dashboardResponse = await getInfoDashboard();
    dashboardData.value = dashboardResponse.data;
    const arrayReportOBJ = await getReportsbyChannels();
    arrayReport1.value = arrayReportOBJ.data;

    if (dashboardData.value) {
      // Extraer valores
      const contactabilityTotal = dashboardData.value.total?.[0]?.total || 0;
      const followTotal = dashboardData.value.follow?.[0]?.total || 0;
      const acceptedTotal = dashboardData.value.total?.[0]?.aceptados || 0;
      const rejectedTotal = dashboardData.value.total?.[0]?.rechazados || 0;

      // Animar valores
      nextTick(() => {
        // Contactabilidad
        numeroContenedor1.value.classList.add("animar");
        animateCount(numero1.value, contactabilityTotal);

        // Seguimiento
        setTimeout(() => {
          numeroContenedor2.value.classList.add("animar");
          animateCount(numero2.value, followTotal);
        }, 500);

        // aceptados
        setTimeout(() => {
          numeroContenedor3.value.classList.add("animar");
          animateCount(numero3.value, acceptedTotal);
        }, 1000);

        // no aceptados
        setTimeout(() => {
          numeroContenedor4.value.classList.add("animar");
          animateCount(numero4.value, rejectedTotal);
        }, 1500);
      });
    }
    if (dashboardData.value?.projects) {
      console.log("dashboardData.value.projects", dashboardData.value);
      projects.value = dashboardData.value.projects;
    }
    if (dashboardData.value?.channels) {
      channels.value = dashboardData.value.channels;
    }

    // Obtener proyectos
    if (clientId) {
      const projectsResponse = await getProjects(clientId);
      projectsComplete.value = projectsResponse.data;
      projectsWithPriorities.value = projects.value.filter(
        (project) =>
          Array.isArray(project.communications) &&
          project.communications.length > 0
      ).length;
    }
    // obtener clientes
    const clientsResponse = await getClients();
    const clients = clientsResponse.data;

    const uniqueClients = new Set(clients.map((client) => client.companyName));
    uniqueClientsCount.value = uniqueClients.size;

    // btener proyectos
    const channelsResponse = await getChannels(clientId);
    const channelsData = channelsResponse.data;

    const uniqueProjects = new Set(
      channelsData.map((channel) => channel.project?.projectsId).filter(Boolean)
    );
    uniqueProjectsCount.value = uniqueProjects.size;

    // proyectos vinculados a reglas
    const rulesResponse = await getRules(clientId);
    const rulesData = rulesResponse.data;

    const uniqueRulesProjects = new Set(
      rulesData.map((rule) => rule.project?.projectsId).filter(Boolean)
    );
    uniqueRulesProjectsCount.value = uniqueRulesProjects.size;

    //reglas válidas
    const today = new Date();
    const rulesWithDates = rulesData.filter(
      (rule) => rule.startDate && rule.endDate
    );

    // contar reglas vigentes y expiradas
    activeRulesCount.value = rulesWithDates.filter((rule) => {
      const startDate = new Date(rule.startDate);
      const endDate = new Date(rule.endDate);
      return startDate <= today && today <= endDate; // Vigentes
    }).length;

    expiredRulesCount.value = rulesWithDates.filter((rule) => {
      const endDate = new Date(rule.endDate);
      return today > endDate; // Expiradas
    }).length;
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

onMounted(fetchData);
</script>
<template>
  <div v-if="route.name === 'Home'" style="padding: 0 2rem;">
    <header>
      <div class="d-flex align-items-center justify-content-between gap-3">
        <h3 style="color: #182631">Uso del Servicio de Contactabilidad</h3>
      </div>
    </header>
    <main>
      <div>
        <div class="d-flex justify-content-between align-items-center mt-2"></div>
        <div class="d-flex justify-content-between">
          <div class="card" style="justify-content: center">
            <div class="d-flex justify-content-center align-items-center">
              <UserGroupIcon style="width: 40px; height: 40px"></UserGroupIcon>
              <div class="d-flex align-items-center">
                <h5 style="margin-bottom: 0; text-align: center">
                  Uso de Servicio de Contactabilidad
                </h5>
                <div class="info-icon-container">
                  <InformationCircleIcon class="info-icon" style="width: 18px; height: 18px; margin-left: 5px; color: #517fa4; cursor: pointer;"></InformationCircleIcon>
                  <div class="info-tooltip right-tooltip">
                    El servicio de contactabilidad permite verificar si los usuarios están disponibles para ser contactados a través de diferentes canales de comunicación. Este servicio es fundamental para optimizar las estrategias de contacto y mejorar las tasas de respuesta.
                  </div>
                </div>
              </div>
            </div>
            <div class="numero-contenedor" ref="numeroContenedor1">
              <span class="numero" :ref="(el) => (numero1 = el)">0</span>
            </div>
          </div>
          <div class="card" style="justify-content: center">
            <div class="d-flex justify-content-center align-items-center gap-3">
              <ChartBarIcon style="width: 40px; height: 40px"></ChartBarIcon>
              <div class="d-flex align-items-center">
                <h5 style="margin-bottom: 0; text-align: center">
                  Uso de Servicio de Seguimiento
                </h5>
                <div class="info-icon-container">
                  <InformationCircleIcon class="info-icon" style="width: 18px; height: 18px; margin-left: 5px; color: #517fa4; cursor: pointer;"></InformationCircleIcon>
                  <div class="info-tooltip right-tooltip">
                    El servicio de seguimiento permite monitorear y analizar el comportamiento de los usuarios después de ser contactados. Este servicio es esencial para medir la efectividad de las campañas y optimizar las estrategias de comunicación.
                  </div>
                </div>
              </div>
            </div>
            <div class="numero-contenedor" ref="numeroContenedor2">
              <span class="numero" :ref="(el) => (numero2 = el)">0</span>
            </div>
          </div>
          <div style="display: flex; flex-direction: column; gap: 1rem">
            <div class="card" style="justify-content: center">
              <div class="d-flex gap-4 justify-content-center align-items-center">
                <HandThumbUpIcon style="width: 30px; height: 30px"></HandThumbUpIcon>
                <div class="d-flex align-items-center">
                  <h6 style="margin-bottom: 0">Usuarios Habilitados</h6>
                  <div class="info-icon-container">
                    <InformationCircleIcon class="info-icon"
                      style="width: 18px; height: 18px; margin-left: 5px; color: #517fa4; cursor: pointer;">
                    </InformationCircleIcon>
                    <div class="info-tooltip left-tooltip">
                      Total de usuarios que se pudieron contactar en las fechas solicitadas.
                    </div>
                  </div>
                </div>
              </div>
              <div class="numero-contenedor" ref="numeroContenedor3">
                <span class="numero-2" :ref="(el) => (numero3 = el)">0</span>
              </div>
            </div>
            <div class="card" style="justify-content: center; background: #243949">
              <div class="d-flex gap-4 justify-content-center align-items-center">
                <HandThumbDownIcon style="width: 30px; height: 30px"></HandThumbDownIcon>
                <div class="d-flex align-items-center">
                  <h6 style="margin-bottom: 0; text-wrap: nowrap">
                    Usuarios <span style="font-weight: 700">no</span> habilitados
                  </h6>
                  <div class="info-icon-container">
                    <InformationCircleIcon class="info-icon"
                      style="width: 18px; height: 18px; margin-left: 5px; color: #517fa4; cursor: pointer;">
                    </InformationCircleIcon>
                    <div class="info-tooltip left-tooltip">
                      Total de usuarios que NO se pudieron contactar en las fechas solicitadas.
                    </div>
                  </div>
                </div>
              </div>
              <div class="numero-contenedor" ref="numeroContenedor4">
                <span class="numero-2" :ref="(el) => (numero4 = el)">0</span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between mt-4" style="height: 16rem">
          <div class="d-flex gap-4 position-relative mt-3">
            <!-- *CARD -->
            <div class="card" style="
                background: #A1C9CA;
                color: #243949;
                width: 32%;
                height: 280px;
                display: flex;
                flex-direction: column;
              ">
              <h5 style="font-weight: 800; margin-top: 1rem">PROYECTOS</h5>
              <div class="d-flex flex-column gap-3 flex-grow-1">
                <div class="d-flex gap-2 align-items-center">
                  <CheckCircleIcon style="width: 30px; height: 30px"></CheckCircleIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    Cuentas con
                    <span style="font-weight: 700">{{ arrayReport1.projects }}</span>
                    Proyectos registrados
                  </h5>
                </div>
                <div class="d-flex gap-2 align-items-center">
                  <CursorArrowRippleIcon style="width: 30px; height: 30px"></CursorArrowRippleIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    <span style="font-weight: 700">{{ projectsWithPriorities }}</span>
                    Proyectos cuentan con prioridades
                  </h5>
                </div>
                <div class="d-flex gap-2 justify-content-between align-items-center">
                  <UserGroupIcon style="width: 30px; height: 30px"></UserGroupIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    Tus proyectos cuentan con
                    <span style="font-weight: 700">{{ uniqueClientsCount }}</span>
                    Clientes distintos
                  </h5>
                </div>
                <div class="d-flex justify-content-end mt-auto">
                  <a href="/dashboard/proyects" class="second-link">IR AL LISTADO</a>
                </div>
              </div>
            </div>

            <!-- *CARD -->
            <div class="card" style="
                background: #73C2CB;
                color: #243949;
                width: 32%;
                height: 280px;
                display: flex;
                flex-direction: column;
              ">
              <h5 style="font-weight: 800; margin-top: 1rem">CANALES</h5>
              <div class="d-flex flex-column gap-3 flex-grow-1">
                <div class="d-flex gap-2 align-items-center">
                  <CheckCircleIcon style="width: 30px; height: 30px"></CheckCircleIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    Cuentas con
                    <span style="font-weight: 700">{{ arrayReport1.channels }}</span>
                    Canales registrados
                  </h5>
                </div>
                <div class="d-flex gap-2 justify-content-between align-items-center">
                  <LinkIcon style="width: 30px; height: 30px"></LinkIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    Tienes
                    <span style="font-weight: 700">{{ uniqueProjectsCount }}</span>
                    Proyectos distintos vinculados a tus Canales.
                  </h5>
                </div>
                <div class="d-flex gap-2 justify-content-between align-items-center">
                  <PlusCircleIcon style="width: 30px; height: 30px"></PlusCircleIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    Tienes
                    <span style="font-weight: 700">{{ dashboardData?.newChannels ?? 0 }}</span>
                    Canales nuevos registrados en los últimos 30 días
                  </h5>
                </div>
                <div class="d-flex justify-content-end mt-auto">
                  <a href="/dashboard/channels" class="second-link">IR AL LISTADO</a>
                </div>
              </div>
            </div>

            <!-- *CARD -->
            <div class="card" style="
                background: #F0CBC7;
                color: #243949;
                width: 32%;
                height: 280px;
                display: flex;
                flex-direction: column;
              ">
              <h5 style="font-weight: 800; margin-top: 1rem">REGLAS</h5>
              <div class="d-flex flex-column gap-3 flex-grow-1">
                <div class="d-flex gap-2 align-items-center">
                  <CheckCircleIcon style="width: 30px; height: 30px"></CheckCircleIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    Cuentas con
                    <span style="font-weight: 700">{{ arrayReport1.rules }}</span>
                    Reglas registradas
                  </h5>
                </div>
                <div class="d-flex gap-2 justify-content-between align-items-center">
                  <LinkIcon style="width: 30px; height: 30px"></LinkIcon>
                  <h5 style="font-size: medium; margin-bottom: 0">
                    Tienes
                    <span style="font-weight: 700">{{ uniqueRulesProjectsCount }}</span>
                    Proyectos distintos vinculados a tus Reglas.
                  </h5>
                </div>
                <div class="d-flex flex-column gap-1">
                  <div class="d-flex gap-1 align-items-center">
                    <CalendarDaysIcon style="width: 20px; height: 20px"></CalendarDaysIcon>
                    <p style="margin-bottom: 0 !important">
                      <span style="font-weight: 700">{{ activeRulesCount }}</span>
                      Reglas vigentes.
                    </p>
                  </div>
                  <div class="d-flex gap-1 align-items-center">
                    <XCircleIcon style="width: 20px; height: 20px"></XCircleIcon>
                    <p style="margin-bottom: 0 !important">
                      <span style="font-weight: 700">{{ expiredRulesCount }}</span>
                      Reglas vencidas.
                    </p>
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-auto">
                  <a href="/dashboard/rules" class="second-link">IR AL LISTADO</a>
                </div>
              </div>
            </div>

            <div class="card" style="
                background: rgb(195, 115, 115);
                position: absolute;
                right: -1%;
                top: -12%;
                max-width: 15rem;
                height: 4rem;
              ">
              <div class="d-flex gap-2 justify-content-around align-items-center">
                <ExclamationCircleIcon style="width: 30px; height: 30px"></ExclamationCircleIcon>
                <h6 style="font-size: smaller; text-wrap: wrap; margin-bottom: 0">
                  Tienes
                  <span style="font-weight: 800">{{ arrayReport1.expiredRules }}</span>
                  Reglas por expirar
                </h6>
              </div>
            </div>
          </div>
        </div>
        <!-- !TABLA -->
        <article class="article" style="margin-top: 5rem;">
          <div class="tabs-container">
            <div class="tabs-description">
              <p>Listado de canales y Proyectos que han hecho uso del servicio de contactabilidad</p>
            </div>
            <div class="tabs-header">
              <button class="tab-button" :class="{ active: selectedTab === 'proyectos' }"
                @click="selectTab('proyectos')">
                <Square3Stack3DIcon style="width: 20px; height: 20px; margin-right: 8px;"></Square3Stack3DIcon>
                Proyectos
              </button>
              <button class="tab-button" :class="{ active: selectedTab === 'canales' }" @click="selectTab('canales')">
                <ShareIcon style="width: 20px; height: 20px; margin-right: 8px;"></ShareIcon>
                Canales
              </button>
            </div>

            <div class="tab-content">
              <div v-if="selectedTab === 'proyectos'" class="tab-pane">
                <div class="list-header">
                  <h5>Lista de Proyectos</h5>
                  <span class="count-badge">{{ projects.length }} proyectos</span>
                </div>

                <div class="list-container">
                  <div v-if="projects.length === 0" class="empty-state">
                    <p>No hay proyectos disponibles</p>
                  </div>

                  <div v-else>
                    <div class="table-header">
                      <div class="header-cell">Nombre</div>
                      <div class="header-cell">Solicitudes</div>
                      <div class="header-cell">Aceptadas</div>
                      <div class="header-cell">Rechazadas</div>
                    </div>

                    <div class="list-items">
                      <div v-for="(project, index) in projects" :key="index" class="list-item">
                        <div class="item-cell">{{ project.project || "Sin nombre" }}</div>
                        <div class="item-cell">{{ (project.total || 0).toLocaleString() }}</div>
                        <div class="item-cell success">{{ (project.aceptados || 0).toLocaleString() }}</div>
                        <div class="item-cell danger">{{ (project.rechazados || 0).toLocaleString() }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="selectedTab === 'canales'" class="tab-pane">
                <div class="list-header">
                  <h5>Lista de Canales</h5>
                  <span class="count-badge">{{ channels.length }} canales</span>
                </div>

                <div class="list-container">
                  <div v-if="channels.length === 0" class="empty-state">
                    <p>No hay canales disponibles</p>
                  </div>

                  <div v-else>
                    <div class="table-header">
                      <div class="header-cell">Nombre</div>
                      <div class="header-cell">Solicitudes</div>
                      <div class="header-cell">Aceptadas</div>
                      <div class="header-cell">Rechazadas</div>
                    </div>

                    <div class="list-items">
                      <div v-for="(channel, index) in channels" :key="index" class="list-item">
                        <div class="item-cell">{{ channel.channel || "Sin nombre" }}</div>
                        <div class="item-cell">{{ (channel.total || 0).toLocaleString() }}</div>
                        <div class="item-cell success">{{ (channel.aceptados || 0).toLocaleString() }}</div>
                        <div class="item-cell danger">{{ (channel.rechazados || 0).toLocaleString() }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </main>
  </div>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";

.switch-container {
  position: relative;
  display: flex;
  width: 300px;
  height: 35px;
  background-color: $white-color;
  border-radius: 50px;
  overflow: hidden;
  padding: 0;
}

.switch-indicator {
  position: absolute;
  width: 50%;
  height: 100%;
  background-color: $primary-color;
  border-radius: 50px;
  transition: transform 0.3s ease;
}

.switch-indicator.left {
  transform: translateX(0%);
}

.switch-indicator.right {
  transform: translateX(100%);
}

.switch-button {
  flex: 1;
  text-align: center;
  background: none;
  border: none;
  outline: none;
  color: $six-color;
  font-weight: bold;
  cursor: pointer;
  z-index: 1;
  transition: color 0.3s ease;
}

.switch-button:hover {
  color: $fourth-color;
}

.td-second {
  color: $fourth-color;
}
th {
  text-wrap: nowrap;
}
.pill {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background: $secondary-color;
  color: $white-color;
  padding: 0px 10px 0px 10px;
  font-size: smaller;
  margin: 0 5px 0 5px;
}
.middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.button-group {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  background-color: $fourth-color;
  padding: 5px;
  border-radius: 50px;
}

.button {
  background: transparent;
  color: $primary-color;
  border: none;
  padding: 5px 10px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
  text-wrap: nowrap;
  font-weight: 700;
}

.button:hover {
  background-color: $fourth-color;
  border-radius: 50px;
}

.card {
  // background: $third-color;
  background: linear-gradient(89.88deg, #18223B 0.08%, #034559 99.87%);
  border-radius: 20px;
  box-shadow: 0px 6px 10px $shadow-color;
  color: $white-color;
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  max-width: 23rem;
  justify-content: space-between;
}
.link {
  color: $fourth-color;
  text-decoration: none;
  font-weight: 600;
  &:hover {
    color: $five-color;
    transition: all ease-in-out 0.3s;
  }

}
.second-link {
  color: $six-color;
  text-decoration: none;
  font-weight: 600;
  &:hover {
    color: $primary-color;
    transition: all ease-in-out 0.3s;
  }

}
.article {
  background-color: $white-color;
  border-radius: 15px;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }
}
.match-rate {
  background-color: $fourth-color;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}
.match-rate-2 {
  background-color: $secondary-color;
  color: $white-color;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}
.collect-users {
  padding: 15px;
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid $seven-color;
  background: transparent;
}

th {
  background-color: $primary-color;
  color: $white-color;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.td-second {
  color: $white-color;
}

.th-second {
  background-color: $primary-color;
  color: $white-color;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

tr:last-child td {
  border-bottom: none;
}

.table-container {
  overflow-x: auto;
  overflow-y: hidden;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.numero-contenedor {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: large;
}

.numero {
  font-size: x-large;
  font-weight: bold;
  animation: contar 2s ease-in-out;
}
.numero-2 {
  font-size: large;
  font-weight: bold;
  animation: contar 2s ease-in-out;
}

@keyframes contar {
  0% {
    content: "0";
  }
  100% {
    content: "34,000";
  }
}

.rounded-lg {
  border-radius: 10px;
  overflow: hidden;
}

.tabs-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.tabs-header {
  display: flex;
  border-bottom: 1px solid $seven-color;
  margin-bottom: 20px;
}

.tab-button {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: $six-color;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    color: $primary-color;
  }
  
  &.active {
    color: $primary-color;
    border-bottom: 3px solid $primary-color;
  }
}

.tab-content {
  flex: 1;
}

.tab-pane {
  animation: fadeIn 0.3s ease;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  
  h5 {
    color: $six-color;
    font-weight: 700;
    margin: 0;
  }
}

.count-badge {
  background-color: $fourth-color;
  color: $primary-color;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.list-container {
  background-color: $white-color;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.table-header {
  display: flex;
  background-color: $primary-color;
  color: $white-color;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  border-bottom: 1px solid $seven-color;
}

.header-cell {
  flex: 1;
  padding: 12px 15px;
  text-align: left;
}

.list-items {
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  padding: 12px 15px;
  border-bottom: 1px solid $seven-color;
  transition: all 0.2s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
}

.item-cell {
  flex: 1;
  text-align: left;
  color: $six-color;
  font-weight: 500;
  
  &.success {
    color: #28a745;
    font-weight: 600;
  }
  
  &.danger {
    color: #dc3545;
    font-weight: 600;
  }
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: $six-color;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.info-icon-container {
  position: relative;
  display: inline-block;
}

.info-icon {
  transition: color 0.2s ease;
}

.info-icon:hover {
  color: #243949 !important;
}

.info-tooltip {
  visibility: hidden;
  position: absolute;
  z-index: 10;
  background-color: white;
  color: #243949;
  text-align: left;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  width: 250px;
  font-size: 0.85rem;
  line-height: 1.4;
  opacity: 0;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.left-tooltip {
  top: 0;
  right: 30px;
}

.left-tooltip::before {
  content: "";
  position: absolute;
  top: 10px;
  right: -8px;
  border-width: 8px;
  border-style: solid;
  border-color: white transparent transparent transparent;
  transform: rotate(90deg);
}

.info-icon-container:hover .info-tooltip {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 768px) {
  .info-tooltip {
    width: 200px;
  }
  
  .left-tooltip {
    right: 0;
    top: 30px;
  }
  
  .left-tooltip::before {
    top: -8px;
    right: 10px;
    transform: rotate(0deg);
  }
}

.tabs-description {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.tabs-description p {
  color: $six-color;
  font-size: 0.95rem;
  font-style: italic;
  margin: 0;
  line-height: 1.4;
}

.right-tooltip {
  top: 0;
  left: 30px;
}

.right-tooltip::before {
  content: "";
  position: absolute;
  top: 10px;
  left: -8px;
  border-width: 8px;
  border-style: solid;
  border-color: white transparent transparent transparent;
  transform: rotate(-90deg);
}

@media (max-width: 768px) {
  .right-tooltip {
    left: 0;
    top: 30px;
  }
  
  .right-tooltip::before {
    top: -8px;
    left: 10px;
    transform: rotate(0deg);
  }
}
</style>
